import { atom } from "recoil";

export const ConfigState = new atom({
  default: {},
  key: "ConfigState",
});
